(function () {
  "use strict";

  angular.module("sempraWebapp").constant("enTranslations", {
    MESSAGE:"Message",
    ERROR_TITLE:"Error",
    ERROR_MESSAGE:"There was an error executing operation.",
    ERROR_LOGIN:"There was an error during log in. Email address or password is not valid",
    ERROR_LOGIN_ROLE: "Role for current application brand is not valid",
    OK:"OK",
    CANCEL:"Cancel",
    YES:"Yes",
    NO:"No",
    UNLIMITED:"Unlimited",
    FROM:"From",
    TO:"To",
    DELETE:"Delete",
    SIGN_OUT:"Sign out",
    NAME:"Name",
    DATE:"Date",
    PIECES:"pieces",
    HOURS:"Hours",
    DAYS:"Days",
    MONTH:"Month",
    MONTHS:"Months",
    YEAR:"Year",
    BOX:"Box",
    SEARCH:"Search",
    ALL_USERS:"All users",
    ARE_YOU_SURE:"Are you sure?",
    BACK:"Back",
    AMOUNT:"Amount",
    DESCRIPTION:"Description",
    FORGOT_PASSWORD_ERROR_MSG:"Something went wrong. Please check your email address and try again",
    REQUIRED_FIELD:"Field is required",
    LOGOUT_TITLE:"Are you sure you want to sign out?",
    LOGOUT_MSG:"All of your unsaved data will be lost",
    ACTIVATION_ACCOUNT:"You successfully activated your account",
    UNKNOWN_ERRROR_NOTIFICATION:"Unknown error occured",
    CONTINUE:"Continue",
    DATA_NOT_AVAILABLE:"Please choose the Report type and select date",
    SELECT:"Select",
    SELECT_CURRENCY:" Select currency",
    UPLOAD:"Upload",
    PHONE:"Phone",
    WEBSITE:"Website",
    WORKING_HOURS:"Working hours",
    INSERT:"Insert",
    TEXT:"Text",
    CREATED:"Created",
    VALID_UNTIL:"Valid until",
    SAVE:"Save",
    TOKENS:"Tokens",
    DELETE_COMPANY_HISTORY:"Delete company history?",
    DELETE_COMPANY_HISTORY_INFO:"This action will delete all report data for your company. This action cannot be undone.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Are you sure you want to permanently delete all reports data?",
    DELETE_COMPANY_HISTORY_MESSAGE:" WARNING: After pressing this button, all transactions of your car wash will be permanently deleted! This data cannot be restored after deletion.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Are you sure you want to permanently delete all transaction data?",
    HISTORY_SUCCESSFULY_DELETED:"History successfully deleted",
    HELP:"Help",
    VALUE:"Value",
    ACTIVATING_ACCOUNT_ERROR:"There was a problem with activation of your R2W  account.Please try again and if the problem persists contact our support at support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Welcome to Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Welcome to R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Please enter your new password and confirm it in order to activate R2W account. You will be automatically signed in into the application upon success",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"You can change your user settings later in application",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:"R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Please enter your new password and confirm it in order to reset old password. You will be automatically signed in into the application upon success",
    RESET_PASSWORD_WELCOME_MSG_3:"You can change your user settings later in application",
    ENTER_NEW_PASSWORD:"Enter new password",
    REPEAT_NEW_PASSWORD:"Repeat new password",
    PASSWORD_MIN_LENGTH:"Password must be at least 8 characters long",
    PASSWORD_MAX_LENGHT:"Password must be less then 32 characters long",
    PASSWORD_PATTERN:"Password must contains at least one uppercase letter and one lowercase letter",
    PASSWORD_MATCH:"Passwords do not match",
    ACTIVATE:"Activate",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"You successfully submitted request. Please check you email for confirmation message",
    VALIDATION_REQUIRED:"Required field",
    VALIDATION_EMAIL:"Invalid email address",
    VALIDATION_INTEGER_NUMBER:"Please enter integer value",
    VALIDATION_HOURS_VALUE:"Value must be between 0-23",
    VALIDATION_MINUTES_VALUE:"Value must be between 0-59",
    VALIDATION_NOT_A_DATE:"Value is not a date",
    VALIDATION_FROM:"From date greater than to",
    VALIDATION_TO:"To date less than from",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"That record already exist in database",
    PASSWORD_VALIDATION_PATTERN_NEW:"There must be at least one digit, one lowercase and one upper case letter. White spaces are not allowed",
    VALIDATION_PERCENT_VALUE:"Value must be between 1-999",
    NUMBERS_ONLY_100:"Counting number up to 100",
    NUMBERS_ONLY_1000:"Counting number up to 1000",
    POSITIVE_NUMBERS_ONLY:"Only counting number",
    GRID_PAGER_PAGE:"Page",
    GRID_PAGER_ROWS_PER_PAGE:"Rows per page",
    GRID_PAGER_PAGE_OF:"of",
    BREAD_CRUMBS_HOME:"Home",
    BREAD_CRUMBS_DASHBOARD_TECH:"Dashboard technology",
    BREAD_CRUMBS_DETAILS:"Details",
    BREAD_CRUMBS_SETTINGS:"Settings",
    BREAD_CRUMBS_WORKING_HOURS:" Working hours",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Total money by days report",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Average money by hour report",
    BREAD_CRUMBS_NEW_USER_GROUP:"Create user group",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Edit user group",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Create campaign template",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Edit campaign template",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Create campaign",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Edit campaign",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Periodic summary",
    LOGIN:"Log in",
    EMAIL:"E-mail",
    PASSWORD:"Password",
    LANGUAGE:"Language",
    FORGOT_PASSWORD:"Forgot password?",
    SUBMIT:"Submit",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Number of pending alarms:",
    HEADER_VIEW_ALL_ALARMS:"View all alarms...",
    HEADER_MY_ACCOUNT:"My account",
    HEADER_ACCOUNT_MANAGEMENT:"Account management",
    ACCOUNT_ALREADY_EXIST:"Email address already in use",
    NEWSLETTER_CONFIRMATION:"Send email notification for alarms state",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Daily Finances Overview",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Dashboard Technology",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Dashboard",
    ASIDE_MENU_ALARMS:"Messages",
    ASIDE_MENU_FACILITIES:"Facilities",
    ASIDE_MENU_REPORTS:"Reports",
    ASIDE_MENU_REPORT:" Selected report",
    ASIDE_MENU_LOYALTY:"Loyalty",
    ASIDE_MENU_USER_GROUPS:"User groups",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodic summary",
    ASIDE_MENU_MANAGING_TOKENS:" Managing Tokens",
    ASIDE_MENU_NEWS:"News",
    DAILY_FINANCES_TOTAL_MONEY:"Total money",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Total money for all facilities",
    DAILY_FINANCES_TOTAL_COINS:"Total used metal tokens",
    DAILY_FINANCES_DOWNLOAD_CSV:"Download CSV",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Cash",
    DAILY_FINANCES_CHANGER:"Changer Cash",
    DAILY_FINANCES_COINS:"Tokens/Eurokey",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Type of report",
    REPORTS_CHOOSE_FACILITY:"Choose facility",
    REPORTS_PERIOD_1:"Period 1 - ",
    REPORTS_PERIOD_2:"Period 2 - ",
    MONEY_BY_DATE_REPORT:"Total income by date",
    R2W_BY_DATE_REPORT:"Total income from R2W tokens by date",
    COINS_BY_DATE_REPORT:"Total used token by date",
    AVG_MONEY_BY_HOUR_REPORT:"Average income by hour",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Average income by day of week",
    AVG_MONEY_BY_BOX_REPORT:"Spending by bay",
    COMPARE_PERIODS_REPORT:"Facility comparative report",
    TOTAL_USERS_BY_GROUP:"Total R2W app visits by day",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"users",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"visits",
    VISITS_COUNT_REPORT:"Number of R2W app users per visit count",
    LOYALTY_PER_DAY_REPORT:"Number of Local tokens spent per day",
    LOYALTY_PER_PAYMENT_METHOD:"Given local tokens per payment method",
    VISITS:"Visits",
    VISIT:"Visit",
    TOTAL_SPENT_MONEY:"Total income",
    MONEY:"Money",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Total income money for period",
    DOWNLOAD_CSV:"Download CSV",
    TOTAL_SPENT_COINS:"Total tokens spent",
    TOTAL_USERS:"Total users",
    TOTAL_CREDIT_GIVEN:"Total local virtual tokens spent",
    EUROKEY_BY_DATE_REPORT:"Total Eurokey payments by date",
    TOTAL_SPENT_EUROKEY:"Total spent",
    SELECT_TYPE_OF_REPORT:"You need to select type of report ",
    NUMBER_OF_VISITS_TITLE:"Number of visits",
    NUMBER_OF_USERS_TITLE:"Number of users",
    PIECES_TITLE:"Pieces",
    TOTAL_VISITS:"Total visits",
    TOKENS_TITLE:"tokens",
    SEARCH_USERS_NO_RESULTS:"No users found for given search term",
    SEARCH_USERS:"Search users",
    SEARCH_TELEPHONES:"Search users by mobile no.",
    ADD_USER_TO_GROUP:"Add user to group",
    ADD_USER_BY_ID:"Add user by ID",
    REMOVE_USER_FROM_GROUP:"Remove user from group",
    USER_GROUP_NAME_REQUIRED:"User group name is required",
    USER_GROUP_NAME:"User group name",
    USER_GROUP_TYPE:"Group type",
    USER_GROUP_TYPE_DEFAULT:"Default",
    USER_GROUP_TYPE_SAVINGS:"Savings",
    USER_GROUPS_OVERVIEW:"User groups overview",
    USER_COUNT:"User count",
    NEW_USER_GROUP:"Create new user group",
    DELETE_USER_GROUP:"Delete user group",
    UPDATE_USER_GROUP:"Edit user group",
    DELETE_USER_GROUP_ERROR:"There was an error deleting selected user group. Please try again or contact support...",
    CONFIRM_DELETE_USER_GROUP:"Are you sure you want to delete the selected user group?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Loyalty actions that the deleted group has been assigned to will no longer be applied.",
    GROUP_NAME_MAX_LENGTH:"Group name must be less then 255 characters long",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"User is already in that group",
    MISSING_USER:"Missing user",
    USER_NOT_ON_LIST:"User is not in the active users list. Check if the email address is valid and try again.",
    UPLOAD_USER_GROUP:"Upload user group list from *.csv file",
    UKNOWN_USERS:"List of uknown users",
    CAMPAIGN_TEMPLATE_RULE:"Template rule",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"There has been an error while trying to delete campaign template. Please try again or contact support...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Are you sure you want to delete selected campaign template",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Are you sure you want to delete selected campaign template",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Campaign templates overview",
    DELETE_CAMPAIGN_TEMPLATE:"Delete campaign template",
    UPDATE_CAMPAIGN_TEMPLATE:"Edit campaign template",
    CREATE_CAMPAIGN_TEMPLATE:"Create new campaign template",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Name of campaign template is required",
    CAMPAIGN_TEMPLATE_NAME:"Campaign template name",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Required field",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"give %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"extra time",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Please select type first. Wash boxes or Small machines.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Delete template rule",
    CAMPAIGN_TEMPLATE_RULE_FROM:"From",
    CAMPAIGN_TEMPLATE_RULE_TO:"to",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"hours",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minutes",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"New rule by number of visits",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"New rule by amount of tokens spent",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"New rule by days of week",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Add new template rule",
    CAMPAIGN_TEMPLATE_RULE_1:"Every",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Every",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"tokens spent in less than",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"visits in less than",
    CAMPAIGN_TEMPLATE_RULE_3:"days",
    CAMPAIGN_TEMPLATE_RULE_4:"tokens",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Rules list is empty.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Date cannot be in the past",
    DELETE_CAMPAIGN_ERROR:"There has been an error while trying to delete campaign. Please try again or contact support...",
    CONFIRM_DELETE_CAMPAIGN:"Are you really sure you want to delete this campaign?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W is not responsible for user's experience caused by this action.",
    CAMPAIGNS_OVERVIEW:"Campaigns overview",
    DELETE_CAMPAIGN:"Delete campaign",
    UPDATE_CAMPAIGN:"Edit campaign",
    CREATE_CAMPAIGN:"Create new campaign",
    CAMPAIGN_ACTIVE:"Active",
    CAMPAIGN_TEMPLATE:"Template",
    CAMPAIGN_GROUPS:"Groups",
    CAMPAIGN_ALL_USERS:"All users",
    CAMPAIGN_NAME:"Campaign name",
    CAMPAIGN_NAME_REQUIRED:"Required",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Number of users near threshold per day",
    MESSAGE_TO_USERS:"Message to filtered users",
    SEND_MESSAGE:"Send message",
    THRESHOLD:"Threshold",
    TYPE:"Type",
    TOTAL_MONEY_SPENT:"Total money spent in campaign",
    NUMBER_OF_VISITS:"Number of visits in campaign",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Message must be at least 10 characters long",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Message must be less then 350 characters long ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Message text is required",
    TECHNOLOGY:"Technology",
    TAP_WATER:"Tap water",
    REVERSE_OSMOSIS:"Reverse osmosis",
    SOFTENED_WATER:"Softened water",
    DOSER:"Doser",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Last synchronization",
    NO_OF_CURRENT_ALARMS:"Number of current alarms",
    NO_OF_CURRENT_WARNINGS:"Number of current warnings",
    WEATHER:"Weather",
    BOXES_WORK_HOURS_COUNTERS:"Boxes work hours",
    BOX_TOTAL_HOURS:"Total work hours",
    BOX_SERVICE_HOURS:"Total work hours (service)",
    BOX_COUNTER_HOURS:"hours",
    ALARMS_AND_WARNINGS:"Alarms & warnings",
    FILTER_AND_BOILER:"Filter & boiler",
    FILTER_TOTAL_DAYS:"Filter work days",
    BOILER_TOTAL_DAYS:"Boiler work days",
    DAYS_UNIT:"days",
    SOFTENER:"Softener",
    MANUAL_COLD_DRAIN:"Manual cold drain",
    EL_COLD:"El. cold",
    DRAIN:"drain",
    TAP:"tap",
    WASTE:"Waste",
    OSMOSIS:"osmosis",
    DEMI_WATER:"Demi water",
    EL_RINSE:"El. m. rinse",
    BOILER:"Boiler",
    EL_WAX:"El. m. wax",
    FLOOR_HEATING:"Floor heating",
    DOSER_TANK:"Doser tank",
    EL_WASH:"El. m. wash",
    DETERGENT:"Detergent",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Update settings",
    GENERAL_SETTINGS:"General settings",
    LIGHTS:"Lights",
    GROUPS:"Groups",
    ANTI_FREEZE:"Anti freeze",
    AUTO:"Auto",
    MANUAL:"Manual",
    ON:"On",
    OFF:"Off",
    TEMPERATURE:"Temperature",
    UPDATE_DEVICE:"Update facility settings",
    BOX_CLEAN_HOURS:"Box clean counters (hours)",
    GROUP_COUNTERS:"Group counters",
    RESET:"Reset",
    CASH_COUNT:"Coins count",
    COINS_COUNT:"Tokens count",
    EUROKEY_COUNT:"Eurokey count",
    DOSER_WORK:"Doser work time (sec.)",
    DOSER_PAUSE:"Doser pause time (sec.)",
    DELAY_BFV:"BFV delay (ms)",
    DELAY_6M1:"6M1 delay (ms)",
    DELAY_LPS:"LPS delay (ms)",
    RESET_CASH_COUNT_ALL:"Reset all coin counters",
    RESET_COINS_COUNT_ALL:"Reset all token counters",
    RESET_EUROKEY_COUNT_ALL:"Reset all Eurokey counters",
    FACILITY_DETAILS:"Facility details",
    FACILITY_NAME:"Facility name",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"You successfully uploaded image",
    FACILITY_UPDATE_DATA_NOTIFICATION:"You successfully updated data",
    CONNECTED:"Connected",
    DISCONNECTED:" Disconnected",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Messages filter",
    FACILITY:"Facility",
    APPLY:"Apply",
    TIME:"Time",
    LOCATION:"Location",
    ACKNOWLEDGED:"Acknowledged",
    FILTERED_MESSAGES:"Filtered messages",
    ACK:"Acknowledged",
    NOT_ACK:"Not acknowledged",
    ALL:"All",
    ALL_FACILITIES:"All facilities",
    ENTER_DATE_PLACEHOLDER:"Enter date",
    OP_NESTANAK_NAPONA:"Missing voltage on phase indicator 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"High pressure pump circuit breaker dropped",
    OP_UPR_NAPON_24VAC_GRE:"Missing 24 VAC - circuit breaker 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Fresh water tank empty",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Mains water pump circuit breaker dropped",
    OP_MIN_NIVO_OMEKS_VODE:"Softened water tank empty",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Softened water pump circuit breaker dropped",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosis water tank empty",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Osmosis water pump circuit breaker dropped",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Osmosis production pump circuit breaker dropped",
    OP_BOJLER_GRESKA_MZS:"Water heater error",
    OP_CRPKA_PRASKA_GRE_MZS:"Hot water pump circuit breaker dropped",
    OP_DOZATOR_PRASKA_GRE_MZS:"Powder dosing motor circuit breaker dropped",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Powder dosing vibrator circuit breaker dropped",
    OP_MIN_PRASAK_TON_ALARM:"Powder mixing tank empty",
    OP_USIS_KOV_TURBINA_GRESKA:"Coin vacuuming turbine circuit breaker dropped",
    OP_FILTER_VODE_ZACEPLJEN:"Water filter blocked",
    OP_VISKTL_RESET_SATI_RADA:"High pressure pump service",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Water filter fault",
    OP_BOJLER_DANI_RADA:"Water heater fault",
    OPW_ALARM_VISOKOTL_PUMPA:"High pressure pump alarm",
    OPW_ALARM_FILTER_SERVIS:"Filter service alarm",
    OPW_ALARM_BOJLER_SERVIS:"Boiler service alarm",
    HAS_MEMBERS:"Selected group has members and can not be deleted. Members need to be deleted first.",
    PERIODIC_SUMMARY_FOR:"Periodic summary report for",
    PERIODIC_SUMMARY_REPORTS:"Periodic summary reports",
    DATE_RANGE:"Date range",
    FINANCIAL_REPORT:"Financial report",
    GROSS_INCOME:"Gross income",
    GROSS_INCOME_SUM:"Gross Income Sum",
    COMMISSION_FEE:"Commission fee",
    NET_INCOME:"Net income (for billing)",
    COMMISSION_FEE_DETAILS:"Commission fee includes bank / PayPal provision or SMS service providers fee.",
    LOYALTY_CREDITS_REPORT:"Local tokens report",
    LOYALTY_GIVEN:"Given local tokens",
    LOYALTY_USED:"Used local tokens",
    LOYALTY_SOLD:"Local tokens loaded",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Current month",
    SOMETHING_WENT_WRONG:"Something went wrong",
    MISSING_PAGE:"Sorry. We could not find that page",
    TRY_AGAIN:"Try again",
    DEFAULT_ERROR_NAME:"Unknown error has occurred",
    DEFAULT_ERROR_DESCRIPTION:"Please try again",
    MY_ACCOUNT_DETAILS:"My account details",
    SAVE_CHANGES:"Save changes",
    USERNAME:"Username",
    FIRST_NAME:"First Name",
    LAST_NAME:"Last Name",
    USER_ROLE:"User Role",
    OLD_PASSWORD:"Old password",
    NEW_PASSWORD:"New password",
    OLD_PASSWORD_REQUIRED:"Old password is required",
    NEW_PASSWORD_REQUIRED:"New password is required",
    NEW_PASSWORD_REPEAT:"New password repeating is required",
    NEW_PASSWORD_NOT_MATCH:"Old and new password does not match",
    PASSWORD_DIFFERENT_VALIDATION:"New password must be different then old one",
    PASSWORD_MIN_CHAR:"Your password must be at least 8 characters long",
    PASSWORD_MAX_CHAR:"Your password must be maximum 32 characters long",
    PASSWORD_PATTERN_VALIDATION:"Password must contains at least one number",
    ACCOUNT_MANAGEMENT:"Account Management",
    NOT_ACTIVE:"Not active",
    ASSIGN_ROLE:"Assign role",
    UPDATE:"Update",
    ADD_NEW_ACCOUNT:"Add new account",
    EMAIL_REQUIRED:"Email adress is required",
    EMAIL_NOT_VALID:"Email adress is not valid",
    ADD_NEW_USER_TEXT:"Email with activation link will be sent to provided email address.",
    UPDATE_USER_NOTIFICATION:"You successfully updated your information",
    CHANGED_PASSWORD_NOTIFICATION:"You successfully changed your password",
    UPDATE_USER_GROUP_NOTIFICATION:"You successfully updated user group name",
    CREATE_USER_GROUP_NOTIFICATION:"You successfully created group",
    DETELE_USER_GROUP_NOTIFICATION:"You successfully deleted group",
    EMPTY_GROUP_LIST_MSG:"There is no created groups. Start by creating one",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"You successfully deleted user from group",
    ADD_USER_TO_GROUP_NOTIFICATION:"You successfully added user to group",
    ADD_USER_NOTIFICATION:"You successfully added new user",
    DELETE_USER_NOTIFICATION:"You successfully deleted user",
    RESEND_USER_VERIFICATION_EMAIL:"You successfully resend verification email",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"In order to create a user group",
    DELETE_USER:"Delete user",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Are you sure you want to delete user from user group?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Dear R2W user",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Loyalty rule per number of visits",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Loyalty rule per amount of tokens spent",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Loyalty rule per day of the week",
    REMOVE_CAMPAIGN_RULE_TITLE:"Campaign rule removal",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Are you sure you want to remove the campaign rule?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"You successfully created new campaign",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"You successfully activated campaign",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"There is no created campaigns. Start by creating one",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"You successfully sent message",
    COMPANY_ACCOUNTS:"Company accounts",
    BUSSINESS_INVOICES_LIST:"My B2B invoices",
    LOCALE_TOKEN:"Local token",
    R2W:"Global token",
    START_MONTH:"Start month",
    END_MONTH:"End month",
    TOKEN_TYPE:"Token type",
    TOKEN_NUMBER:"Token number",
    NOTHING_TO_DISPLAY:"* Nothing to display",
    CREATE_INVOICE:"Create Invoice",
    INVOICE:"Invoice",
    INVOICES:"Invoices",
    EDIT_INVOICE:"Edit invoice",
    UPDATE_INVOICE_NOTIFICATION:"You successfully updated invoice to pending status",
    CURRENT_CHARGES:"Charges for the current period",
    PAYMENTS_ON_HOLD:"Invoices in processing",
    FOR_INVOICING:"For invoicing",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"You are about to cancel invoice",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Are you sure you want to cancel this invoice ?",
    INVOICING_NOTIFICATION_HEADER:"You are about to do invoicing",
    INVOICING_NOTIFICATION_TEXT:"Are you sure you want to send invoice?",
    SENT_INVOICE_NOTIFICATION:"You successfully sent an invoice",
    CANCELED_INVOICE_NOTIFICATION:"You successfully canceled invoice",
    INVOICE_DESCRIPTION_TEXT:"Invoice for ",
    INVOICE_STATE:"Invoice state",
    INVOICE_NUMBER:"Invoice number",
    INVOICE_TOTAL:"Total",
    SELECT_YEAR:"Select year",
    DOWNLOAD:"Download PDF",
    INVOICE_NUMBER_HEADER:"You are about to send invoice with number ",
    INVOICE_PAYMENT_CONFIRMATION:"You are about to confirm payment for",
    INSERT_INVOICE_NUMBER:"Insert invoice number",
    INVOICED_WARNING:"The email was not sent. Please wait ...",
    SEND_INVOICE:"Send",
    INVOICE_ALL:"All",
    INVOICE_FROM_R2W:"From R2W",
    INVOICE_TO_R2W:"To R2W",
    PAYMENT_REQUEST:"Payment request",
    PAYMENT_REQUEST_STATE:"Payment request state",
    PAYMENT_REQUEST_NUMBER:"Payment request number",
    FOR_PAYMENT_REQUEST:"For payment requests",
    PAYMENT_REQUEST_ON_HOLD:"Payment requests in process",
    DOWNLOAD_INVOICE:"Download invoice",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Click for download options",
    B2B_SPEC:"B2B specification",
    B2C_SPEC:"B2C specification",
    DOWNLOAD_PAYMENT_REQUEST:"Download payment request",
    LOYALTY_PREVIEW:"Loyalty preview",
    ACTIVATED:"Activated",
    RUNNING:"Running",
    NOT_ACTIVATED:"Not activated",
    FINISHED:"Finished",
    DEPRECATED:"Deprecated",
    UPCOMING:"Upcoming",
    NONE:"Individual",
    STARTED:"Started",
    ENDS:"Ends",
    DEDICATED:"Dedicated to",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"You are about to activate",
    CAMPAIGN:"Campaign",
    SEND_MESSAGE_NOTIFICATION:"You are about to send message to selected user groups",
    DIVISIBLE_TO_NUMBER:"The number should be divisible with ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Device type",
    LISTENER:"Small machines",
    BRIDGE:"Wash boxes",
    WASH_BOXES:"Wash boxes",
    VACUUMS:" Vacuums",
    SAVE_NEWS:"Save news",
    CREATE_NEW_NEWS:"Create new news",
    HISTORY_OF_ALL_NEWS:"History of all news",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Type facility name",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Add another facility",
    NEWS_TEXT:"News text",
    NEWS_TITLE:"News title",
    DELETE_NEWS_CONFIRMATION:"You are about to delete news",
    NEWS_DELETE_NOTIFICATION:"You successfully deleted news",
    NEWS_SAVE_NOTIFICATION:"You successfully saved news",
    NEWS_CREATION_DATE:"Creation date",
    NO_TITLE:"No title",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"News text must be less then 255 characters",
    NEWS_TEXT_REQUIRED_VALIDATION:"News text is required",
    NEWS_TITLE_REQUIRED_VALIDATION:"News title is required",
    DEACTIVATE:"Deactivate",
    ASIDE_MENU_LOCAL_TOKENS:"Local tokens",
    CREATE_NEW_LOCAL_TOKENS:"Issue new local tokens",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Enter customer email address and amount of local tokens you would like to issue to the customer",
    CREATE_TOKENS:"Issue tokens",
    MINIMUM_ONE_TOKEN:"Value must be number greater than 0",
    CUSTOMER_EMAIL:"Customer email",
    AMOUNT_OF_TOKENS:"Amount of tokens",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Success issuing local tokens to",
    PROBLEM_ISSUING_LOCAL_TOKENS:"There was an error issuing local tokens. Please check customer email address and try again.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Overview of issued local tokens",
    ISSUED_AT:"Issued at",
    ISSUED_BY:"Issued by",
    CODE:"Redeem code",
    REDEEMED_BY:"Redeemed by",
    REDEEMED_AT:"Redeemed at",
    ASIDE_MENU_VOUCHERS:"Vouchers",
    PRINT:"Print",
    VOUCHERS_OVERVIEW:"Vouchers overview",
    CREATE_NEW_VOUCHERS:"Create new vouchers",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Create new redeemable voucher batch by entering amount of tokens per voucher",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Amount of tokens per voucher",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"You can assign between 1 and 100 tokens per voucher",
    NUMBER_OF_NEW_VOUCHERS:"Number of vouchers to be created",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"You can create between 1 and {{size}} vouchers in a single batch",
    NEW_VOUCHERS_PREFIX:"New vouchers series code prefix",
    VALIDATION_VOUCHER_PREFIX:"Code prefix must be exactly 4 characters (upper cased letters and/or numbers)",
    PROBLEM_CREATING_NEW_VOUCHERS:"There was a problem creating new vouchers. Please try again or contact our support.",
    CREATE_VOUCHERS:"Create vouchers",
    CREATE_AND_PRINT_VOUCHERS:"Create and print vouchers",
    CREATE_AND_PRINT_VOUCHERS_VACC:"Create and print vouchers - VACC",
    CREATING_VOUCHERS_SUCCESS:"New vouchers created sucessfully",
    PRINT_NEW_VOUCHERS:"Print vouchers",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Enter a voucher series code prefix in order to print entire voucher series. Alternatively",
    PRINT_VOUCHERS_PREFIX:"Voucher (series) code prefix",
    NO_VOUCHERS_FOR_PRINT:"No vouchers matching provided code prefix were found for printing",
    PRINT_VOUCHERS:"Print voucher(s)",
    VALIDATION_VOUCHER_CODE_FILTER:"Voucher search term must consist of upper case letters and numbers",
    FILTER_VOUCHERS_BY_CODE:"Search vouchers by redeem code",
    FILTER_VOUCHERS:"Search vouchers",
    WASH_BOX:"Wash box",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Total used digital tokens",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Total sold local tokens by date",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Total spent local tokens by date",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Total given local tokens by date",
    LOCAL_TOKEN:"Local token ",
    GIVEN_TOKEN:"Given local tokens",
    SOLD_TOKEN:"Sold local tokens",
    SMALL_MACHINES:"Small machines",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle wash box",
    CODE_PREFIX_EXIST:"Code prefix already exist",
    CODE_PREFIX_EXIST_TEXT:"You can't create new voucher with this code prefix. Please set another one.",
    MIN_FOUR_VALIDATION:"Exactly 4 characters",
    ALL_INFORMATION_1:"All information about",
    ALL_INFORMATION_2:"will be lost",
    ASIDE_MENU_TRANSACTIONS:"Transactions",
    EXPENSES:"Expenses",
    TOPUPS:"Top-ups",
    EXPENSES_LIST:"Expenses list",
    USER_EMAIL:"User email",
    COMPANY_NAME:"Company name",
    TOPUPS_LIST:"Top-ups list",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serial number",
    SETUP_UNIT_MATERIAL_NO:"Material number",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi version",
    TOTAL_TURNOVER:"Wash facility turnover",
    AVAILABILITY_ALL:"Availability",
    AVAILIBILITY:"Wash boxes availability:",
    AVAILABILITY_VACUUMS:"Vacuums availability:",
    WASH_BOX_INFO:"Wash boxes info",
    VACUUM_CLEANER_INFO:"Vacuum cleaners info",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Holidays",
    HOLIDAY:"Holiday",
    LIGHTS_ON:"Lights on",
    LIGHTS_OFF:"Lights off",
    WASH_BOXES_ON:"Wash box on",
    WASH_BOXES_OFF:"Wash box off",
    VACUUMS_ON:"Vacuums on",
    VACUUMS_OFF:"Vacuums off",
    TURNOVER:"Turnover",
    TURNOVER_MANUAL_WASH_UNIT:"Turnover manual",
    STATUS_BAY_RUN_TIME:"Wash box total work time",
    STATUS_BAY_PROGRAM_NAME:"Program name",
    STATUS_BAY_CREDIT:"Wash box credit",
    CLOUD_KREDIT:"Cloud credit",
    STATUS_VACUUM_RUN_TIME:"Vacuum total work time",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facility services, wash box program and current fault data information",
    UNAVAILABLE:"Unit is unavailable",
    SHOW_HIDE_TABLE:"Show/hide working hours table",
    PROGRAM_NAME:"Program name",
    PROGRAM_COUNTER:"Program counter",
    NO_NAME:"Reference has no name",
    COUNTER_SERVICE_DATA:"Service data",
    NEED_SERVICE:" Service needed",
    PROGRAM_DATA:"Wash box program data",
    CURRENT_FAULT_DATA:"Current fault data",
    REFERENCE_DUE:"Due",
    REFERENCE_SECONDS:"Seconds",
    REFERENCE_NAME:"Part name",
    WASHBOX_NAME:"Wash box name",
    FAULT_NAME:"Fault name",
    FAULT_NUMBER:"Fault number",
    CURRENT_FAULT_COUNT:"Active faults",
    DEVICE_NOT_INSTALLED:"Device not installed",
    STATUS_READY:" Ready status",
    STATUS_ERROR:" Error status",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:" Software error",
    SOFTWARE_RESET:" Software error",
    EXTERNAL_PIN_RESET:" Software error",
    RESTART_OR_BROWNOUT_OCCURRED:" Software error",
    DEAD_RM5_CHANNEL_PIN_ERROR:" Hardware error",
    COULD_NOT_SIMULATE_COIN:" Hardware error",
    ERROR_SETTING_INHIBIT_MODE:" Hardware error",
    OFFLINE_DEVICE:" Offline car wash",
    TARIFFS:" Tariffs",
    DAY:" Day",
    NIGHT:" Night",
    VOUCHER_CODE:" Voucher code",
    DISMISS_ALARM:" Reset alarm?",
    ALARM_ACTIVE:" Active alarms",
    NO_ALARM_ACTIVE:" There are no active alarms",
    ALARM_HISTORY:" Alert history",
    MANAGING_TOKENS:"Managing tokens",
    EXPIRATION_DATE:"Expiration date",
    EXTEND_TOKEN_DATE:"Extend token expiration date for",
    DELETE_TOKENS_FOR:"Delete tokens for ",
    PUMP_TYPE:"Pump type",
    TURN_OFF_DEVICE:" Device status",
    OPERATION_DATA:" Operation data",
    PUMP_DATA:" Pump data",
    PUMP_NAME:" Pump name",
    POINT_NAME:" Point name",
    CHANGER_INCOME:" Total changer income by date",
    SELECTED_OPEN:"Open on selected working hours",
    ALWAYS_OPEN:" Always open (24/7)",
    CLOSED:" Closed",
    CLOSED_24:" Closed 24h",
    OPENED_24:" Opened 24h",
    MON:" Monday",
    TUE:" Tuesday",
    WED:" Wednesday",
    THU:" Thursday",
    FRI:" Friday",
    SAT:" Saturday",
    SUN:" Sunday",
    PRICING:" Pricing",
    PRICE:"Price",
    SO_PRICE:"Special offer price",
    VALIDITY:"Validity",
    TOKEN_PACKAGES:" Token packages",
    SINGLE_WASH:" Single wash",
    FACILITY_WORKING_HOURS:" Set working hours for selected facility",
    WORKING_HOURS_ALWAYS_OPEN:" Always open",
    WORKING_HOURS_ALWAYS_CLOSE:" Closed by operator",
    WORKING_HOURS_CUSTOM:" Set working hours",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor buffer tank empty activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor buffer container empty and buffer contianer full switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor ro pump on and buffer container full switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:" Organization",
    CREATE_ORGANIZATION:" Create organization",
    CREATE_ORGANIZATION_AS:" Create organization as child for",
    DELETE_ORGANIZATION:" Delete organization",
    EDIT_ORGANIZATION:" Edit organization",
    SUPPORTED_ORG_NAME:" Supported organization",
    SUPPORTED_ORG_TYPE:" Supported type",
    ORG_NAME:" Name",
    ORG_TYPE:" Type",
    SET_ORG_TITLE:" Set child organization",
    SET_SUPPORTED_ORG_TITLE:" Set supported child organization",
    SAVE_ORGANIZATION:" Save organization",
    SELECT_ORGANIZATION_TYPE:" Select organization type",
    SELECT_ORGANIZATION_SELECTOR:"Select",
    SELECT_SUPPORTED_ORGANIZATION:" Supported by",
    ORGANIZATION_DELETED:" Organization successfully deleted",
    ORGANIZATION_SAVED:" Organization successfully saved",
    ORGANIZATION_UPDATED:" Organization successfully updated",
    ALERTS:" Alerts",
    DEVICE_STATUS:" Device status",
    SITE_DETAILS:" Site details",
    ALARM_STATUS:" Alert status",
    FILTER:" Filter by ...",
    FILTER_BY_ALERT_CENTER:"Filter by code, name or description",
    TOTAL_ALARM:" Total",
    LOW_ALARM:" Event",
    MEDIUM_ALARM:"Malfunction",
    HIGH_ALARM:"Critical fault",
    NO_FACILITIES_NEARBY:" There are no nearby facilities",
    GRAY_MAP:" Gray styled map",
    READY:" Ready",
    WARNING:"Malfunction",
    ERROR:" Error",
    SITE_NAME:" Site name",
    ACCOUNTS_INFO:" Account info",
    USER_ORGANIZATION:" User organization",
    ADD_USER_ORGANIZATION:" Add new organization user",
    EDIT_USER_ORGANIZATION:"Edit users of the organisation",
    SELECT_ROLE:" Select role",
    SELECT_ORGANIZATION:" Select organization",
    SELECT_USER:" Select user",
    USER_FOR_ORGANIZATION_CREATED:" New user created successfully",
    SELECT_REGION:" Select region",
    SELECT_LANGUAGE:" Select language",
    LOADING_DATA:" Loading data, please wait ...",
    ADMINISTRATOR:" Administrator",
    TECHNICAL_SUPPORT:" Technical support",
    CONTROLLER:"Controller",
    EDIT_ORGANIZATION_USER:"Edit users of the organisation",
    DELETE_ORGANIZATION_USER:"Delete users of the organisation",
    USER_UPDATED:" User successfully updated",
    USER_CREATED:" User successfully created",
    ADDRESS:"Address",
    SUBSCRIPTIONS:"Subscriptions",
    RESOLVED_STATUS:"Resolved",
    NOT_RESOLVED_STATUS:"Not resolved",
    ALERT_NAME:" Alert name",
    ALERT_DESCRIPTION:" Alert description",
    ALERT_CODE:"Alert code",
    ALERT_TYPE:" Alert type",
    UNSUBSCRIBE:" Unsubscribe alert",
    SUBSCRIBE:"Subscribe alert",
    ALARM_SUBSCRIBED:"Successfully subscribed",
    UNSUBSCRIBED_CONFIRM:" Unsubscribe?",
    ALARM_UNSUBSCRIBED:" Successfully unsubscribed",
    ASIDE_MENU_CASHLESS_SALES:" Cashless Sales",
    FILTERED_CASHLESS_PAYMENTS:" Filtered cashless payments",
    REFUND_DIALOG_TITLE:" Refund transaction?",
    REFUND_DIALOG_SUBTITLE:" Amount can be less than or equal to transaction amount",
    REFUND:" Refund",
    INPUT_NOT_VALID:" Input is not valid",
    REFUND_SUCCESSFULLY:" Refund for selected payment was successfully done",
    USER:"User",
    TRANSACTION_ID:" PSP reference",
    DEVICE_ID:" Device ID",
    NET_AMOUNT:" Net amount",
    REPORT_NAME:" Report name",
    TIME_FRAME:" Time frame",
    SUB_POINT:" Select sub point",
    SUB_POINT_LIST_NOT_EXIST:" Sub point list not exist for selected wash facility",
    FACILITY_TYPE:" Facility type",
    MACHINE_NAME:"Machine name",
    WASH_FACILITY_DETAILS:" Wash facility details",
    WASH_BAY_DETAILS:" Wash bay details",
    DEVICES_INFO:"Devices list",
    OPERATION_TIME_INFO:"Operation time",
    OPERATION_TIME_VACUUM_INFO:"Operation time for vacuum cleaners",
    OPERATION_TIME_ILLUMINATION_INFO:"Operation time for illumination",
    AVAILABLE_TITLE:"Available",
    UNAVAILABLE_TITLE:"Unavailable",
    CURRENT_PROGRAM:" Current program",
    CREDITS:" Credits",
    DEVICE_NAME:" Device name",
    ACTIVE_ALARMS:" Active alerts",
    ALL_DAY:" All day",
    OPERATING_TIME_WASH_FACILITY:" Self-service wash system",
    OPERATING_TIME_VACUUMS:" Vacuums",
    OPERATING_TIME_ILLUMINATION:" Illumination",
    OPERATION_COUNTERS:" Operation counters",
    EDIT:" Edit",
    WASHING_PROGRAMS:" Washing programs",
    INFO:"Event",
    STATISTIC:"Statistic",
    ROLLOVER_DOSING:"Dosing",
    ROLLOVER_SPEED:" Speeds",
    ROLLOVER_RESETS:" Rollover remote reset",
    ROLLOVER_RESETS_INFO:" The remote reset has to be in accordance with local regulations. Important: Before resetting make sure that rollover is empty.",
    RESET_ROLLOVER:" Reset rollover",
    OPEN_DOOR_ROLLOVER:" Open",
    ROLLOVER_OPEN_DOOR_INFO:"Open wash hall door. Be careful.",
    ROLLOVER_OPEN_DOOR:" Open the door",
    APPLY_DOSING_CHANGES:" Apply dosing changes",
    APPLY_SPEED_CHANGES:" Apply speed changes",
    ACTUATION_SUCCESS:"Request sent",
    REMAINING_TIME:" Remaining time",
    OPEN_24H:" Open 24 hours",
    CLOSE_24H:" Close 24 hours",
    VALIDATION_OPERATION_TIME:" Format not correct. Use hh:mm",
    ROLLOVER:" Rollover",
    UPDATE_WASHING_PROGRAM:" Update washing program",
    UPDATE_ACTUATORS:"Update actuators",
    OPEN_ROLOVER_DOOR_TITLE:" Want to open rollover door?",
    OPEN_ROLOVER_DOOR_CONTENT:" Are you sure you want to open the door?",
    RESET_ROLOVER_TITLE:" Want to reset rollover?",
    RESET_ROLOVER_CONTENT:" Are you sure you want to reset rollover?",
    G0:"{{brand === 'r2w' ? 'Bay 0' : 'Bay 1'}}",
    G1:"{{brand === 'r2w' ? 'Bay 1' : 'Bay 2'}}",
    G2:"{{brand === 'r2w' ? 'Bay 2' : 'Bay 3'}}",
    G3:"{{brand === 'r2w' ? 'Bay 3' : 'Bay 4'}}",
    G4:"{{brand === 'r2w' ? 'Bay 4' : 'Bay 5'}}",
    G5:"{{brand === 'r2w' ? 'Bay 5' : 'Bay 6'}}",
    G6:"{{brand === 'r2w' ? 'Bay 6' : 'Bay 7'}}",
    G7:"{{brand === 'r2w' ? 'Bay 7' : 'Bay 8'}}",
    G8:"{{brand === 'r2w' ? 'Bay 8' : 'Bay 9'}}",
    G9:"{{brand === 'r2w' ? 'Bay 9' : 'Bay 10'}}",
    G10:"{{brand === 'r2w' ? 'Bay 10' : 'Bay 11'}}",
    U0:"{{brand === 'r2w' ? 'Vacuum 0' : 'Vacuum 1'}}",
    U1:"{{brand === 'r2w' ? 'Vacuum 1' : 'Vacuum 2'}}",
    U2:"{{brand === 'r2w' ? 'Vacuum 2' : 'Vacuum 3'}}",
    U3:"{{brand === 'r2w' ? 'Vacuum 3' : 'Vacuum 4'}}",
    U4:"{{brand === 'r2w' ? 'Vacuum 4' : 'Vacuum 5'}}",
    U5:"{{brand === 'r2w' ? 'Vacuum 5' : 'Vacuum 6'}}",
    U6:"{{brand === 'r2w' ? 'Vacuum 6' : 'Vacuum 7'}}",
    U7:"{{brand === 'r2w' ? 'Vacuum 7' : 'Vacuum 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:" Alert center report created by selected site from dashboard",
    ALERT_CENTER_TITLE_BY_FACILITY:" Alert center report created by selected facility from dashboard",
    ALERT_CENTER_TITLE_BY_DEFAULT:" Alert center report",
    ERROR_MESSAGE_403:" You don't have privilege to use this api call. Error Code: 403",
    LAST_ACTIVE_PROGRAM:"Active program / Last active program",
    PROGRAM_ID:"Program number",
    PROGRAM_PRICE:"Program price",
    PROGRAM_SO_PRICE:"Special offer price",
    PROGRAM_DESCRIPTION: "Program description",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Refill required",
    EMPTY_CHEMICAL_LEVEL:"Empty",
    CHEMICAL_LEVEL:"Level indication detergents (%)",
    ROLLOVER_STATUS:" Rollover status",
    ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
    ROLLOVER_STATUS_CODE_1:" Outside operating time",
    ROLLOVER_STATUS_CODE_2:" Program entry allowed",
    ROLLOVER_STATUS_CODE_3:"Position your vehicle",
    ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
    ROLLOVER_STATUS_CODE_5:"Vehicle back",
    ROLLOVER_STATUS_CODE_6:"Vehicle stop",
    ROLLOVER_STATUS_CODE_7:"Wash active",
    ROLLOVER_STATUS_CODE_8:"Wash stopped",
    ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
    ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
    ROLLOVER_STATUS_CODE_11:"Emergency stop",
    ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
    ROLLOVER_STATUS_CODE_13:"Anti frost active",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
    ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Critical fault",
    NO_ALARM:"No critical fault",
    SOFTWARE_VERSION:"Software version",
    SOFTWARE_DATE:"Software date",
    SITE_ADDRESS:"Site address",
    SECONDS:"Seconds",
    SERVICE_PART_NAME:" Service name:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:" Operation and service counter",
    OPERATION_COUNTER:" Operation counter",
    SERVICE_COUNTER:" Service counter",
    FAULT_CODE:"Alert code",
    PRESSURE_TITLE:"Air pressure",
    TIME_TITLE:"Current time",
    COUNTRY_TITLE:"Country",
    CITY_TITLE:"City",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Select points ...",
    LOGS_HISTORY:"Parameter change history",
    ACTUATOR_REFERENCE:" Actuator reference",
    ACTUATOR_VALUE:" Actuator value",
    POINT_ID:" Point id",
    VALIDATION_NOT_VALID_RANGE:" Incorrect range",
    ENABLE_ROLLOVER_RESET:"By ticking this box you confirm that you have read and agree with the safety instructions.",
    CHANGE_OF_PARAMETERS:" Change of parameters",
    SELECT_OPTIONS:" Select options",
    AUTOMATIC:" Automatic",
    DESALTING:" Desalting function",
    SEASON_WASH:" Season wash programs",
    SPRING_PROGRAM:" Spring washing programs",
    SUMMER_PROGRAM:" Summer washing programs",
    AUTUMN_PROGRAM:" Autumn washing programs",
    WINTER_PROGRAM:" Winter washing programs",
    DOOR_CONTROL:"Door control",
    SUMMER_DOOR_CONTROL:" Summer, operated with the gate control in summer mode",
    WINTER_DOOR_CONTROL:" Winter, operated with the gate control in winter mode",
    APPLY_PARAMETERS_CHANGES:" Apply parameters changes",
    WORKING_SCHEDULES:" Working schedules",
    HOLIDAY_SCHEDULES:" Holiday schedules",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:" Holidays on site successfully created",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:" Holidays on site successfully updated",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:" Holidays on site successfully deleted",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:" Working schedules successfully propagate",
    HOLIDAY_SUCCESSFULLY_DELETED:" Holiday successfully deleted",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Drying agent with low filling level",
    CHEM_LEVEL_LOW_SHAMPOO:"Shampoo with low filling level",
    CHEM_LEVEL_LOW_FOAM:"Foam with low filling level",
    CHEM_LEVEL_LOW_WAX_1:"Wax with low filling level",
    CHEM_LEVEL_LOW_POLISH_1:"Polish with low filling level",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Rim cleaner with low filling level",
    CHEM_LEVEL_LOW_WAX_2:"Wax with low filling level",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Tyre shine with low filling level",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Insect remover with low filling level",
    CHEM_LEVEL_LOW_POLISH_2:"Polish with low filling level",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensive with low filling level",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Foam rain with low filling level",
    CHEM_LEVEL_DRYING_AGENT:"Filling level drying agent",
    CHEM_LEVEL_SHAMPOO:"Filling level shampoo",
    CHEM_LEVEL_FOAM:"Filling level foam",
    CHEM_LEVEL_WAX_1:"Filling level wax",
    CHEM_LEVEL_POLISH_1:"Filling level polish",
    CHEM_LEVEL_RIM_CLEANER:"Filling level rim cleaner",
    CHEM_LEVEL_WAX_2:"Filling level wax",
    CHEM_LEVEL_TYRE_SHINE:"Filling level tyre shine",
    CHEM_LEVEL_INSECT_REMOVER:"Filling level insect remover",
    CHEM_LEVEL_POLISH_2:"Filling level polish",
    CHEM_LEVEL_INTENSIVE:"Filling level intensive ",
    CHEM_LEVEL_FOAM_RAIN:"Filling level foam rain",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Service counter roof-brush lifting belt",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Service counter dryer lifting belt",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Service counter motor cable roof-brush",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Service counter fresh water pump service",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Service counter pump service used water",
    DRYING_AGENT:"Drying agent",
    FOAM_DRYING_AGENT:"Foam drying agent",
    SHAMPOO:"Shampoo",
    FOAM:"Foam",
    BRUSH_FOAM:"Brush foam",
    WAX_1:"Wax",
    FOAM_WAX_1:"Foam wax",
    POLISH_1:"Polish",
    RIM_CLEANING:"Rim cleaner",
    WAX_2:"Wax",
    FOAM_WAX_2:"Foam wax",
    TYRE_SHINE:"Tyre shine",
    INSECT_REMOVER:"Insect remover",
    POLISH_2:"Polish",
    INTENSIVE_BASIC:"Intensive basic",
    INTENSIVE_SIDE:"Intensive side",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensive roof spray bar",
    TAR_REMOVER:"Tar remover",
    UNDER_CHASSIS_CONVERSATION:"Under chassis conversation",
    STATIONARY_PRE_SPRAY_ARCH:"Stationary pre-spray arch",
    FOAM_RAIN:"Foam rain",
    PRE_CLEANING:"Pre-cleaning",
    BRUSH:"Brush",
    CARE:"Care",
    DRYING:"Drying",
    DRYING_LOW_NOISE:"Drying reduced noise",
    INTENSIVE_CLEANING:"Intensive cleaning",
    BRUSH_CLEANING:"Brush cleaning",
    EMPTY_RUN:"Empty run",
    DRYING_AID:"Drying aid",
    WAX:"Wax",
    FOAM_WASH:"Foam wash",
    POLISH:"Polish",
    FOAM_POLISH:"Foam polish",
    WHEEL_CLEANING:"Wheel cleaning",
    HIGH_PRESSURE_ROOF:"Roof high pressure",
    HIGH_PRESSURE_SIDE:"Side high pressure",
    DRYER_FORWARD:"Dryer forward",
    DRYER_BACKWARD:"Dryer backward",
    DELETE_ALL_HOLIDAYS:"Delete all holidays for selected site",
    CREATE_NEW_HOLIDAY:"Create new",
    RESET_INPUTS:"Reset all holidays inputs",
    TWENTY_FOUR_HOURS_OPEN:"Open 24 hours",
    EVERY_YEAR:"Yearly",
    DELETE_HOLIDAY:"Delete holiday",
    ADD_NEW_HOLIDAY:"Add new holiday",
    HOLIDAYS_LIST:"List of existing holidays",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Delete all holidays for selected site?",
    VALIDATION_HOLIDAY_DATE:"Format not correct. Use dd-mm",
    FOR_DATE:"For date",
    WITH_ID:"With ID",
    FROM_HOURS:"From (h)",
    FROM_MINUTES:"From (min)",
    TO_HOURS:"To (h)",
    TO_MINUTES:"To (min)",
    NOT_MATCH:"Not match",
    START:"Start",
    STOP:"Stop",
    DAILY_TIME: "24 hours list",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individual time setting",
    PROGRAM_NOT_STARTED:"Program not started yet",
    JETWASH:"Self-service wash system",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Fresh water pump",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Process water pump",
    OPERATION_COUNTER_HP_PUMP_1:"High pressure pump 1",
    OPERATION_COUNTER_HP_PUMP_2:"High pressure pump 2",
    RELEASE_NOTES: "App versions and release notes",
    BACKEND_RELEASE_NOTES: "Platform release notes:",
    FRONTEND_RELEASE_NOTES: "Web application release notes:",
    SELECTED_FACILITY_TIMEZONE: "Time zone for selected facility:",
    REFRESH_PAGE: "Refresh page",
    REFRESH_MAPS: "Refresh maps",
    PUMPS: "Pumps",
    RUN_TIME: "Run time",
    RUN_TIME1: "Run time 1",
    RUN_TIME2: "Run time 2",
    PROGRAM_RUNTIME_ACTUATOR: "Actuator for run time",
    PROGRAM_RUNTIME_ACTUATOR_1: "Actuator for run time 1",
    PROGRAM_RUNTIME_ACTUATOR_2: "Actuator for run time 2",
    PUMP_RUN_TIME_MIN_VALIDATION: "Min value is 1",
    PUMP_RUN_TIME_MAX_VALIDATION: "Max value is 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION: "Use price format x.xx",
    ACTUATION_NOT_ALLOWED:" Actuation not allowed for current user role",
    MAINTENANCE_DAYS: "Maintenance days",
    MAINTENANCE_WASHES: "Maintenance washes",
    DAILY_FINANCES_POS: "POS",
    POS_INCOME: "Total income POS",
    PROPAGATE: "Propagate",
    ALL_DAY_HOURS_SELECTOR: "24 hours type selector",
    GET_OPERATING_TIME_FROM_SITE: "Get operating time for current device from site working schedules",
    USER_NOT_VALID: "User is not valid. Try with another account credentials.",
    VERIFIED: "Verified",
    RESEND_VERIFICATION_MAIL: "Resend verification email",
    RETURN_TO_DASHBOARD: "Return to dashboard",
    ERROR_PAGE_BAD_REQUEST:"400 Bad Request.",
    WASHES: "Number of washes",
    TIME_TO_SERVICE: "Time to service",
    ACCOUNT_ALREADY_ACTIVATED: "Account already activated",
    DEVICE_EVENTS: "Device events",
    DEVICE_EVENTS_LOG_PULLED: "Pulled event log for device ",
    EVENTS_PULL_DATE: "Pulled events time: ",
    DEVICE_EVENTS_REFRESH: "Pull new event data",
    WEB_SOCKETS_CONNECTION_PROBLEM: "Web sockets connection problem. Try to refresh page.",
    INSTALLATION_DATE: "Installation date of machine",
    KARCHER_CUSTOM_PROGRAM_NAME_1: "Hot wax",
    KARCHER_CUSTOM_PROGRAM_NAME_2: "High pressure washing",
    KARCHER_CUSTOM_PROGRAM_NAME_3: "Power rim foam",
    KARCHER_CUSTOM_PROGRAM_NAME_4: "Power foam",
    KARCHER_CUSTOM_PROGRAM_NAME_5: "Stop",
    KARCHER_CUSTOM_PROGRAM_NAME_6: "Foam wash HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7: "Wash",
    KARCHER_CUSTOM_PROGRAM_NAME_8: "Top care",
    INFO_TITLE: "Info",
    FOAM_WAX1:"Foam wax",
    POLISH1:"Polish",
    WAX1:"Wax",
    SITE_DETAILS_SUCCESSFULLY_UPDATED: "Site details successfully updated",
    COMPANY: "Company",
    FACILITY_HAS_CHANGER: "Have changer?",
    DISABLE_OFFLINE_ALARM: "Disable R2W alarms",
    ASIDE_WORKING_SCHEDULES: "App Site details",
    TERMS_OF_SERVICE_R2W_TITLE: "Ready2Wash terms of service",
    TERMS_OF_SERVICE_R2W: "Ready2Wash terms of service",
    DATA_PROCESSING_TITLE: "Data Processed",
    PRIVACY_POLICY_TITLE: "Privacy Policy",
    READY_TO_PAY_TERMS_OF_SERVICE: "Ready2Pay Terms of service",
    TERMS_AND_SERVICES: "Terms and services",
    HOURLY: "Hourly",
    DAILY: "Daily",
    WEEKLY: "Weekly",
    MONTHLY: "Monthly",
    YEARLY: "Yearly",
    DELETE_ITEM_SUCCESS:"You successfully deleted item",
    STATE: "State",
    AVAILABILITY_STATUS_1: "Unit open",
    AVAILABILITY_STATUS_2: "Unit closed (holiday)",
    AVAILABILITY_STATUS_3: "Unit closed (operating time)",
    AVAILABILITY_STATUS_4: "Unit closed (fault)",
    AVAILABILITY_STATUS_5: "Unit closed (other)",
    AVAILABILITY_VACUUMS_STATUS_1: "Vacuums not installed",
    AVAILABILITY_VACUUMS_STATUS_2: "Vacuums open",
    AVAILABILITY_VACUUMS_STATUS_3: "Vacuums closed (holiday)",
    AVAILABILITY_VACUUMS_STATUS_4: "Vacuums closed (operating time)",
    AVAILABILITY_VACUUMS_STATUS_5: "Vacuums closed (fault)",
    AVAILABILITY_VACUUMS_STATUS_6: "Vacuums closed (other)",
    ECOM_AMOUNT: "Total Ecom for All Sites",
    CAPTURED: "Captured",
    VALUE_DATE: "Value date",
    VALIDATION_HOLIDAY_YEAR: "Format not correct. Use yyyy",
    KARCHER_EVENT_NAME_1: "Base exchanger regenerated",
    KARCHER_EVENT_NAME_2: "Base exchanger regeneration ended",
    KARCHER_EVENT_NAME_3: "Material / serial number",
    KARCHER_EVENT_NAME_4: "The system has been disinfected",
    KARCHER_EVENT_NAME_5: "HP pump 1 has been disinfected",
    KARCHER_EVENT_NAME_6: "HP pump 2 has been disinfected",
    KARCHER_EVENT_NAME_7: "HP pump 3 has been disinfected",
    KARCHER_EVENT_NAME_8: "HP pump 4 has been disinfected",
    KARCHER_EVENT_NAME_9: "HP pump 5 has been disinfected",
    KARCHER_EVENT_NAME_10: "Washing station 1 locked",
    KARCHER_EVENT_NAME_11: "Washing station 2 locked",
    KARCHER_EVENT_NAME_12: "Washing station 3 locked",
    KARCHER_EVENT_NAME_13: "Washing station 4 locked",
    KARCHER_EVENT_NAME_14: "Washing station 5 locked",
    KARCHER_EVENT_NAME_15: "Washing station 6 locked",
    KARCHER_EVENT_NAME_16: "Washing station 7 locked",
    KARCHER_EVENT_NAME_17: "Washing station 8 locked",
    KARCHER_EVENT_NAME_18: "Update started",
    KARCHER_EVENT_NAME_19: "Update finished",
    KARCHER_EVENT_NAME_20: "Start WS Reg",
    KARCHER_EVENT_NAME_21: "End WS Reg",
    KARCHER_EVENT_NAME_22: "WS 75% sensor",
    KARCHER_EVENT_NAME_23: "Tech. defect",
    KARCHER_EVENT_NAME_24: "Oper. defect",
    KARCHER_EVENT_NAME_25: "Unit on",
    KARCHER_EVENT_NAME_26: "Unit closed",
    KARCHER_EVENT_NAME_27: "Box 1 closed",
    KARCHER_EVENT_NAME_28: "Box 2 closed",
    KARCHER_EVENT_NAME_29: "Box 3 closed",
    KARCHER_EVENT_NAME_30: "Box 4 closed",
    KARCHER_EVENT_NAME_31: "Box 5 closed",
    KARCHER_EVENT_NAME_32: "Box 6 closed",
    KARCHER_EVENT_NAME_33: "Box 7 closed",
    KARCHER_EVENT_NAME_34: "Box 8 closed",
    KARCHER_EVENT_NAME_35: "HP pump bay 1",
    KARCHER_EVENT_NAME_36: "HP pump bay 2",
    KARCHER_EVENT_NAME_37: "HP pump bay 3",
    KARCHER_EVENT_NAME_38: "HP pump bay 4",
    KARCHER_EVENT_NAME_39: "HP pump bay 5",
    KARCHER_EVENT_NAME_40: "HP pump bay 6",
    KARCHER_EVENT_NAME_41: "HP pump bay 7",
    KARCHER_EVENT_NAME_42: "HP pump bay 8",
    KARCHER_EVENT_NAME_43: "Burner",
    KARCHER_EVENT_NAME_44: "Burner fan",
    KARCHER_EVENT_NAME_45: "Warm water pump",
    KARCHER_EVENT_NAME_46: "Freeze prot.pump",
    KARCHER_EVENT_NAME_47: "Osmosis pump",
    KARCHER_EVENT_NAME_48: "Floor heating",
    KARCHER_EVENT_NAME_49: "Hose heating",
    KARCHER_EVENT_NAME_50: "Microe/rim clean",
    KARCHER_EVENT_NAME_51: "Underc. pump",
    KARCHER_EVENT_NAME_52: "Booster pumpFoam",
    KARCHER_EVENT_NAME_53: "Vacuum clean. 1",
    KARCHER_EVENT_NAME_54: "Vacuum clean. 2",
    KARCHER_EVENT_NAME_55: "Vacuum clean. 3",
    KARCHER_EVENT_NAME_56: "Vacuum clean. 4",
    KARCHER_EVENT_NAME_57: "Vacuum clean. 5",
    KARCHER_EVENT_NAME_58: "Vacuum clean. 6",
    KARCHER_EVENT_NAME_59: "Vacuum clean. 7",
    KARCHER_EVENT_NAME_60: "Vacuum clean. 8",
    KARCHER_EVENT_NAME_61: "Vacuum clean. 9",
    KARCHER_EVENT_NAME_62: "Vacuum clean. 10",
    KARCHER_EVENT_NAME_63: "Vacuum clean. 11",
    KARCHER_EVENT_NAME_64: "Vacuum clean. 12",
    KARCHER_EVENT_NAME_65: "Pump rim clean",
    KARCHER_EVENT_NAME_66: "Pump Microe.",
    KARCHER_EVENT_NAME_67: "Pump Intensive",
    KARCHER_EVENT_NAME_68: "Vacuum1 turbine",
    KARCHER_EVENT_NAME_69: "Vacuum1 filter",
    KARCHER_EVENT_NAME_70: "Vacuum2 turbine",
    KARCHER_EVENT_NAME_71: "Vacuum2 filter",
    KARCHER_EVENT_NAME_72: "Vacuum3 turbine",
    KARCHER_EVENT_NAME_73: "Vacuum3 filter",
    KARCHER_EVENT_NAME_74: "Vacuum4 turbine",
    KARCHER_EVENT_NAME_75: "Vacuum4 filter",
    KARCHER_EVENT_NAME_76: "Vacuum5 turbine",
    KARCHER_EVENT_NAME_77: "Vacuum5 filter",
    KARCHER_EVENT_NAME_78: "Vacuum6 turbine",
    KARCHER_EVENT_NAME_79: "Vacuum6 filter",
    KARCHER_EVENT_NAME_80: "Vacuum7 turbine",
    KARCHER_EVENT_NAME_81: "Vacuum7 filter",
    KARCHER_EVENT_NAME_82: "Vacuum8 turbine",
    KARCHER_EVENT_NAME_83: "Vacuum8 filter",
    KARCHER_EVENT_NAME_84: "Vacuum9 turbine",
    KARCHER_EVENT_NAME_85: "Vacuum9 filter",
    KARCHER_EVENT_NAME_86: "Vacuum10 turbine",
    KARCHER_EVENT_NAME_87: "Vacuum10 filter",
    KARCHER_EVENT_NAME_88: "Vacuum11 turbine",
    KARCHER_EVENT_NAME_89: "Vacuum11 filter",
    KARCHER_EVENT_NAME_90: "Vacuum12 turbine",
    KARCHER_EVENT_NAME_91: "Vacuum12 filter",
    INSERT_TOKEN:  "Insert tokens and start service",
    OPEN_SESSION: "Session successfully opened",
    IN_PROGRESS: "In progress ...",
    TOKEN_INSERTED: "Tokens inserted successfully",
    EXPIRED_SESSION: "Session expired",
    TWO_DIGIT_INTEGER_VALIDATION: "Use max two digit integer",
    KARCHER_OPERATION_COUNTER_1: "Washing station 1 HP pump",
    KARCHER_OPERATION_COUNTER_2: "Washing station 1 chemical pump 1",
    KARCHER_OPERATION_COUNTER_3: "Washing station 1 chemical pump 2",
    KARCHER_OPERATION_COUNTER_4: "Washing station 1 chemical pump 3",
    KARCHER_OPERATION_COUNTER_5: "Washing station 1 chemical pump 4",
    KARCHER_OPERATION_COUNTER_6: "Washing station 2 HP pump",
    KARCHER_OPERATION_COUNTER_7: "Washing station 2 chemical pump 1",
    KARCHER_OPERATION_COUNTER_8: "Washing station 2 chemical pump 2",
    KARCHER_OPERATION_COUNTER_9: "Washing station 2 chemical pump 3",
    KARCHER_OPERATION_COUNTER_10: "Washing station 2 chemical pump 4",
    KARCHER_OPERATION_COUNTER_11: "Washing station 3 HP pump",
    KARCHER_OPERATION_COUNTER_12: "Washing station 3 chemical pump 1",
    KARCHER_OPERATION_COUNTER_13: "Washing station 3 chemical pump 2",
    KARCHER_OPERATION_COUNTER_14: "Washing station 3 chemical pump 3",
    KARCHER_OPERATION_COUNTER_15: "Washing station 3 chemical pump 4",
    KARCHER_OPERATION_COUNTER_16: "Washing station 4 HP pump",
    KARCHER_OPERATION_COUNTER_17: "Washing station 4 chemical pump 1",
    KARCHER_OPERATION_COUNTER_18: "Washing station 4 chemical pump 2",
    KARCHER_OPERATION_COUNTER_19: "Washing station 4 chemical pump 3",
    KARCHER_OPERATION_COUNTER_20: "Washing station 4 chemical pump 4",
    KARCHER_OPERATION_COUNTER_21: "Washing station 5 HP pump",
    KARCHER_OPERATION_COUNTER_22: "Washing station 5 chemical pump 1",
    KARCHER_OPERATION_COUNTER_23: "Washing station 5 chemical pump 2",
    KARCHER_OPERATION_COUNTER_24: "Washing station 5 chemical pump 3",
    KARCHER_OPERATION_COUNTER_25: "Washing station 5 chemical pump 4",
    KARCHER_OPERATION_COUNTER_26: "Washing station 6 HP pump",
    KARCHER_OPERATION_COUNTER_27: "Washing station 6 chemical pump 1",
    KARCHER_OPERATION_COUNTER_28: "Washing station 6 chemical pump 2",
    KARCHER_OPERATION_COUNTER_29: "Washing station 6 chemical pump 3",
    KARCHER_OPERATION_COUNTER_30: "Washing station 6 chemical pump 4",
    KARCHER_OPERATION_COUNTER_31: "Washing station 7 HP pump",
    KARCHER_OPERATION_COUNTER_32: "Washing station 7 chemical pump 1",
    KARCHER_OPERATION_COUNTER_33: "Washing station 7 chemical pump 2",
    KARCHER_OPERATION_COUNTER_34: "Washing station 7 chemical pump 3",
    KARCHER_OPERATION_COUNTER_35: "Washing station 7 chemical pump 4",
    KARCHER_OPERATION_COUNTER_36: "Washing station 8 HP pump",
    KARCHER_OPERATION_COUNTER_37: "Washing station 8 chemical pump 1",
    KARCHER_OPERATION_COUNTER_38: "Washing station 8 chemical pump 2",
    KARCHER_OPERATION_COUNTER_39: "Washing station 8 chemical pump 3",
    KARCHER_OPERATION_COUNTER_40: "Washing station 8 chemical pump 4",
    KARCHER_OPERATION_COUNTER_41: "Osmosis pump",
    KARCHER_OPERATION_COUNTER_42: "Hot water generator",
    KARCHER_OPERATION_COUNTER_43: "Frost protection pump",
    KARCHER_OPERATION_COUNTER_44: "WSO filter inlay",
    KARCHER_OPERATION_COUNTER_45: "Washing station heater pump",
    KARCHER_OPERATION_COUNTER_46: "Hot water pump",
    KARCHER_OPERATION_COUNTER_47: "Foam hose heating",
    KARCHER_OPERATION_COUNTER_48: "Wheel cleaning pump",
    KARCHER_OPERATION_COUNTER_49: "Micro-emulsion pump",
    KARCHER_OPERATION_COUNTER_50: "Intensive foam pump",
    KARCHER_OPERATION_COUNTER_51: "Vacuum cleaner 1 turbine 1",
    KARCHER_OPERATION_COUNTER_52: "Vacuum cleaner 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Vacuum cleaner 1 turbine 2",
    KARCHER_OPERATION_COUNTER_54: "Vacuum cleaner 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Vacuum cleaner 2 turbine 1",
    KARCHER_OPERATION_COUNTER_56: "Vacuum cleaner 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Vacuum cleaner 2 turbine 2",
    KARCHER_OPERATION_COUNTER_58: "Vacuum cleaner 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Vacuum cleaner 3 turbine 1",
    KARCHER_OPERATION_COUNTER_60: "Vacuum cleaner 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Vacuum cleaner 3 turbine 2",
    KARCHER_OPERATION_COUNTER_62: "Vacuum cleaner 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Vacuum cleaner 4 turbine 1",
    KARCHER_OPERATION_COUNTER_64: "Vacuum cleaner 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Vacuum cleaner 4 turbine 2",
    KARCHER_OPERATION_COUNTER_66: "Vacuum cleaner 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Vacuum cleaner 5 turbine 1",
    KARCHER_OPERATION_COUNTER_68: "Vacuum cleaner 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Vacuum cleaner 5 turbine 2",
    KARCHER_OPERATION_COUNTER_70: "Vacuum cleaner 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Vacuum cleaner 6 turbine 1",
    KARCHER_OPERATION_COUNTER_72: "Vacuum cleaner 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Vacuum cleaner 6 turbine 2",
    KARCHER_OPERATION_COUNTER_74: "Vacuum cleaner 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Drain condensation water from the compressor",
    KARCHER_OPERATION_COUNTER_76: "Check frost protection system",
    KARCHER_OPERATION_COUNTER_77: "Burner fan",
    KARCHER_OPERATION_COUNTER_78: "Booster pump foam",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Data list is larger than 10000 items",
    KARCHER_POINT_NAME_1: "Holiday",
    KARCHER_POINT_NAME_2: "Monday",
    KARCHER_POINT_NAME_3: "Tuesday",
    KARCHER_POINT_NAME_4: "Wednesday",
    KARCHER_POINT_NAME_5: "Thursday",
    KARCHER_POINT_NAME_6: "Friday",
    KARCHER_POINT_NAME_7: "Saturday",
    KARCHER_POINT_NAME_8: "Sunday",
    KARCHER_POINT_NAME_9: "Vacuums Holiday",
    KARCHER_POINT_NAME_10: "Vacuums Monday",
    KARCHER_POINT_NAME_11: "Vacuums Tuesday",
    KARCHER_POINT_NAME_12: "Vacuums Wednesday",
    KARCHER_POINT_NAME_13: "Vacuums Thursday",
    KARCHER_POINT_NAME_14: "Vacuums Friday",
    KARCHER_POINT_NAME_15: "Vacuums Saturday",
    KARCHER_POINT_NAME_16: "Vacuums Sunday",
    KARCHER_POINT_NAME_17: "Illumination Holiday",
    KARCHER_POINT_NAME_18: "Illumination Monday",
    KARCHER_POINT_NAME_19: "Illumination Tuesday",
    KARCHER_POINT_NAME_20: "Illumination Wednesday",
    KARCHER_POINT_NAME_21: "Illumination Thursday",
    KARCHER_POINT_NAME_22: "Illumination Friday",
    KARCHER_POINT_NAME_23: "Illumination Saturday",
    KARCHER_POINT_NAME_24: "Illumination Sunday",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR code",
    ACCEPT_TERMS_AND_CONDITIONS: "Accept terms and conditions",
    CODE_PREFIX_QUESTION: "Code prefix is not entered",
    CODE_PREFIX_QUESTION_TEXT: "Do you want to proceed without a code prefix?",
    ISSUED_DATE: "Issued date",
    VOUCHER_VALIDITY_DAYS: "Voucher validity (days)",
    ROLLOVER_VOUCHER_VALIDITY_DAYS: "Rollover voucher validity (days)",
    VALIDATION_ONLY_NUMBERS: "Only numbers are allowed",
    REPRINT_VOUCHERS: "Print copy of vouchers",
    EXPIRY_DATE: "Valid until",
    VOUCHER_EXPIRATION_DAYS_UPDATED: "Voucher expiration days updated successfully",
    ROLLOVER_VOUCHER_EXPIRATION_DAYS_UPDATED: "Rollover voucher expiration days updated successfully",
    ASIDE_MENU_ROLLOVER: "Rollover vouchers",
    ROLLOVER_WELCOME_TITLE: "Rollover Device Selection",
    ROLLOVER_SITE: "Site",
    ROLLOVER_SITE_NAME_PLACEHOLDER: "Your Site",
    ROLLOVER_SELECT_DEVICE: "Select a Rollover Device",
    ROLLOVER_NO_DEVICES: "No rollover devices available at this site",
    ROLLOVER_STATUS_ONLINE: "Online",
    ROLLOVER_STATUS_OFFLINE: "Offline",
    ROLLOVER_PROGRAMS_AVAILABLE: "programs available",
    ROLLOVER_DEVICE_UNAVAILABLE: "Device unavailable",
    ROLLOVER_SELECT: "Select",
    ROLLOVER_PROGRAM_SELECTION: "Program Selection",
    ROLLOVER_DEVICE: "Device",
    ROLLOVER_SELECT_PROGRAM: "Select a Program",
    ROLLOVER_NO_PROGRAMS: "No programs available for this device",
    ROLLOVER_CHOOSE_PROGRAM: "Choose Program",
    ROLLOVER_PROGRAMS: "Programs",
    ROLLOVER_OPTIONS: "Options",
    ROLLOVER_SELECT_OPTION: "Select Option",
    ROLLOVER_OPTIONS_SELECTION: "Options Selection",
    ROLLOVER_SELECTED_PROGRAM: "Selected Program",
    ROLLOVER_NO_OPTIONS: "No options available for this program",
    ROLLOVER_TOTAL_PRICE: "Total Price",
    ROLLOVER_CONFIRM_SELECTION: "Confirm Selection",
    ROLLOVER_SELECT_OPTIONS: "Select Options",
    ROLLOVER_CONFIGURATION: "Configuration",
    ROLLOVER_SUMMARY: "Summary",
    ROLLOVER_PROGRAM: "Program",
    ROLLOVER_SELECT_PROGRAM_HINT: "Select a program from the list to see available options",
    ROLLOVER_SALES_TYPE: "Sales Type",
    ROLLOVER_NUMBER_OF_WASHES: "Number of Washes",
    ROLLOVER_WASHES: "washes",
    ROLLOVER_VALIDITY_PERIOD: "Validity Period",
    ROLLOVER_VALID_FROM: "Valid From",
    ROLLOVER_VALIDITY_DAYS: "Days",
    ROLLOVER_VALID_TO: "Valid To",
    ROLLOVER_HAPPY_HOUR: "Happy Hour",
    ROLLOVER_HAPPY_HOUR_PERIOD_1: "Period 1",
    ROLLOVER_HAPPY_HOUR_PERIOD_2: "Period 2",
    ROLLOVER_START_TIME: "Start Time",
    ROLLOVER_END_TIME: "End Time",
    ROLLOVER_INVALID_TIME_FORMAT: "Invalid format. Use HH:mm (e.g. 08:00, 23:59)",
    ROLLOVER_END_MUST_BE_AFTER_START: "End time must be after start time",
    ROLLOVER_PRINT: "Print",
    ROLLOVER_CREATE_AND_PRINT: "Create and Print Voucher",
    ROLLOVER_VIEW_VOUCHERS: "View Vouchers",
    ROLLOVER_CREATE_VOUCHER: "Create Voucher",
    ROLLOVER_VOUCHERS: "Rollover Vouchers Overview",
    ROLLOVER_NO_VOUCHERS: "No vouchers issued at this site",
    ROLLOVER_SEARCH_VOUCHERS_PLACEHOLDER: "Search vouchers by redeem code or issued by",
    ROLLOVER_SEARCH_VOUCHERS: "Search vouchers",
    ROLLOVER_VOUCHER_CODE: "Voucher Code",
    ROLLOVER_VOUCHER_STATUS: "Status",
    ROLLOVER_VOUCHER_TOKENS: "Washes",
    ROLLOVER_VOUCHER_REDEEMED: "Redeemed",
    ROLLOVER_VOUCHER_ISSUED_DATE: "Issued Date",
    ROLLOVER_VOUCHER_EXPIRES: "Expires",
    ROLLOVER_VOUCHER_ISSUED_BY: "Issued By",
    ROLLOVER_VOUCHER_ACTION: "Note",
    ROLLOVER_VOUCHER_ACTIONS: "Actions",
    ROLLOVER_DEACTIVATE_VOUCHER: "Deactivate voucher",
    ROLLOVER_DEACTIVATE_TITLE: "Deactivate voucher",
    ROLLOVER_DEACTIVATE_CONFIRM: "Are you sure you want to deactivate this voucher?",
    ROLLOVER_VALIDITY_FROM: "Valid from",
    ROLLOVER_VALIDITY_FROM_HINT: "Leave empty for immediate validity",
    ROLLOVER_PRINT_VOUCHER: "Print voucher",
    ROLLOVER_REMAINING_WASHES: "Remaining washes",
    ROLLOVER_CANCEL: "Cancel",
    ROLLOVER_CREATING: "Creating...",
    ROLLOVER_OPTIONS_SELECTED: "Options selected",
    ROLLOVER_SALES_TYPES: "Sales Types",
    ROLLOVER_SALES_TYPE_ACTIVE: "Active",
    ROLLOVER_SALES_TYPE_UPDATED: "Sales type updated successfully",
    ROLLOVER_NO_SALES_TYPES: "No sales types available",
    ROLLOVER_ZERO_PRICE: "Zero Price",
    ROLLOVER_SPECIAL_OFFER_PRICES: "Special Offer Prices",
    ROLLOVER_UNLIMITED_WASHES: "Unlimited Washes",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    SUCCESS: "Success",
    ASIDE_MENU_SAVINGS: "Savings",
    SAVINGS_TITLE: "Savings Accounts",
    SAVINGS_DESCRIPTION: "Manage savings accounts for users with SAVINGS origin",
    SAVINGS_SEARCH_PLACEHOLDER: "Search by user ID or company",
    SAVINGS_USERS_LIST: "Savings Users",
    SAVINGS_NO_USERS: "No savings users found",
    SAVINGS_USER_ID: "User ID",
    SAVINGS_COMPANY: "Company",
    SAVINGS_BALANCE: "Balance",
    SAVINGS_INITIAL_CREDIT: "Initial Credit",
    SAVINGS_REMAINING_CREDIT: "Remaining Credit",
    SAVINGS_CREATED_DATE: "Created Date",
    SAVINGS_STATUS: "Status",
    SAVINGS_EXPIRATION_DATE: "Expiration Date",
    SAVINGS_ACTIONS: "Actions",
    SAVINGS_DEACTIVATE: "Deactivate",
    SAVINGS_DEACTIVATE_TITLE: "Deactivate Savings Account",
    SAVINGS_DEACTIVATE_MESSAGE: "Are you sure you want to deactivate this savings account?",
    SAVINGS_PACKAGES: "Savings Packages",
    SAVINGS_CREDIT_AMOUNT: "Credit Amount",
    SAVINGS_EXPIRATION_DAYS: "Savings Validity Days",
    SAVINGS_EXPIRATION_DAYS_UPDATED: "Savings validity days updated successfully",
    SAVINGS_CREATE_TITLE: "Create new user",
    SAVINGS_SALE_TYPE: "Sale Type",
    SAVINGS_SALE_TYPE_REGULAR: "Regular",
    SAVINGS_SALE_TYPE_PACKAGE: "Package",
    SAVINGS_SELECT_PACKAGE: "Select Package",
    SAVINGS_PACKAGE: "Package",
    SAVINGS_AMOUNT: "Amount",
    SAVINGS_VALIDITY_PERIOD: "Validity Period",
    SAVINGS_VALID_FROM: "Valid From",
    SAVINGS_VALID_TO: "Valid To",
    SAVINGS_VALIDITY_DAYS: "Validity Days",
    SAVINGS_SUMMARY: "Summary",
    SAVINGS_CREATE_AND_PRINT: "Create & Print",
    SAVINGS_CREATING: "Creating...",
    SAVINGS_TAB_USERS: "Users",
    SAVINGS_TAB_GROUPS: "Savings Groups",
    SAVINGS_GROUPS_LIST: "Savings Groups",
    SAVINGS_CREATE_GROUP: "Create Group",
    SAVINGS_GROUP_SEARCH_PLACEHOLDER: "Search by group name or description",
    SAVINGS_NO_GROUPS: "No savings groups found",
    SAVINGS_GROUP_NAME: "Group Name",
    SAVINGS_GROUP_DESCRIPTION: "Description",
    SAVINGS_GROUP_MEMBERS: "Members",
    ROLLOVER_SEARCH_VOUCHER_PLACEHOLDER: "Enter voucher code...",
    ROLLOVER_SEARCH: "Search",
    ROLLOVER_VOUCHER_NOT_FOUND: "Voucher not found",
    ROLLOVER_VOUCHER_SEARCH_ERROR: "Error searching for voucher",
    ROLLOVER_INVALID_CODE_SUFFIX: "Invalid voucher code. Code must end with ROLL.",
    ROLLOVER_VOUCHER_DETAILS: "Voucher Details",
    ROLLOVER_PURCHASE_DATE: "Purchase Date",
    ROLLOVER_VALIDITY_START: "Validity Start",
    ROLLOVER_VALIDITY_END: "Validity End",
    ROLLOVER_BLOCKED_STATUS: "Blocked Status",
    ROLLOVER_WASH_PROGRAM: "Wash Program Number",
    ROLLOVER_SELECTED_OPTIONS: "Selected Options",
    ROLLOVER_WASHES_SOLD: "Number of Washes Sold (Initial)",
    ROLLOVER_WASHES_AVAILABLE: "Number of Washes Available (Remaining)",
    ROLLOVER_UNLIMITED: "Unlimited",
    ROLLOVER_REDEMPTION_HISTORY: "Redemption History",
    ROLLOVER_NO_REDEEMS: "No redemptions recorded",
    ROLLOVER_REDEEM_DATE: "Date",
    ROLLOVER_REDEEM_SITE: "Site",
    ROLLOVER_REDEEM_DEVICE: "Device",
    ROLLOVER_STATUS_ACTIVE: "Active",
    ROLLOVER_STATUS_REDEEMED: "Redeemed",
    ROLLOVER_STATUS_EXPIRED: "Expired",
    ROLLOVER_STATUS_BLOCKED: "Blocked",
    ROLLOVER_PRINT_CONFIRMATION: "Print Confirmation",
    ROLLOVER_PRINT_UNSUCCESSFUL_MESSAGE: "If your print was unsuccessful, please use this code below.",
    ROLLOVER_DEACTIVATE: "Deactivate",
    CONFIRM: "Confirm",
    CLOSE: "Close"
  });
})();
